import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useRef } from 'react';
export function withOverrideCss(Component) {
  return function (props) {
    var ref = useRef(null);
    useEffect(function () {
      if (props !== null && props !== void 0 && props.className && ref.current) {
        ref.current.className = "".concat(ref.current.className, " ").concat(props.className);
      }
    }, [props === null || props === void 0 ? void 0 : props.className]);
    return /*#__PURE__*/React.createElement(Component, _extends({}, props, {
      ref: ref
    }));
  };
}